import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';

const getOptileInit = async ({
    requestId, sessionId, query: {paymentSessionId, languageCode}
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {requestId, sessionId, paymentSessionId};

    logger.info('Retrieving Optile init data', {
        eventId: eventIds['Retrieving Optile init data'],
        ...logProps
    });

    try {
        const url = new URL(`/${languageCode}/sessions/${paymentSessionId}/init`, config.optile.api);

        const headers = {
            'X-WR-PLATFORM': 'WEB'
        };

        const initResponse = await fetch(url.toString(), {
            headers
        });

        throwOnResponseError(initResponse);

        const initData = await initResponse.json();

        logger.info('Retrieved Optile init data', {
            eventId: eventIds['Retrieved Optile init data'],
            ...logProps,
            payload: initData
        });

        return initData;
    } catch (e) {
        const error = new Error(`Error retrieving Optile init data: ${e.message}`);
        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Optile init data'],
            ...logProps
        });

        throw error;
    }
};

export default getOptileInit;
